import React, {Component} from 'react';
import Action from 'components/organisms/players-to-exchange/actions';
import Const from 'const';
import {connect} from 'react-redux';
import PlayerInterface from 'interfaces/players-data-interfaces/player-interface';
import LineupInterface from 'interfaces/lineups-data-interfaces/lineup-interface';
import LineupsInterface from 'interfaces/lineups-data-interfaces/lineups-interface';
import {replaceLineupPlayer} from 'helpers/lineup-helper';
import {createChecksumForLineupPlayers} from 'helpers/hash';
import {showPopup, closePopup} from 'helpers/modal';
import AvailablePlayers from 'components/organisms/players-to-exchange/index';
import {assertEditedLineupIsValid} from 'services/validations';

interface Props {
    searchPlayer: PlayerInterface;
    replacePlayer: PlayerInterface;
    lineup: LineupInterface;
    lineups: LineupsInterface;
    sportConfig;
    dispatch;
}

class SwapPlayersButton extends Component<Props> {
    onClick(): void {
        const {searchPlayer, replacePlayer, lineup, lineups, sportConfig, dispatch} = this.props;
        const lineupPlayers = replaceLineupPlayer(searchPlayer, replacePlayer, lineup.players);
        const playersChecksum = createChecksumForLineupPlayers(lineupPlayers);

        if (lineups.hasLineupWithPlayerChecksum(playersChecksum)) {
            return dispatch(
                showPopup(Const.LATESWAP_DUPLICATED_LINEUP_ON_PLAYER_SWAP_MESSAGE, {
                    onConfirm: () => this.swapPlayerAndClosePopup(),
                    onCancel: () =>
                        dispatch(
                            showPopup(
                                <AvailablePlayers
                                    lineup={lineup}
                                    playerToBeSwapped={searchPlayer}
                                    sportConfig={sportConfig}
                                />,
                                {
                                    useConfirm: false,
                                    useClose: true,
                                    type: 'details',
                                },
                            ),
                        ),
                    useCancel: true,
                }),
            );
        }

        try {
            assertEditedLineupIsValid({sportConfig, lineupPlayers});
        } catch (e) {
            if (!(e instanceof Error)) {
                throw e;
            }

            return dispatch(
                showPopup(e.message, {
                    onConfirm: () =>
                        dispatch(
                            showPopup(
                                <AvailablePlayers
                                    lineup={lineup}
                                    playerToBeSwapped={searchPlayer}
                                    sportConfig={sportConfig}
                                />,
                                {
                                    useConfirm: false,
                                    useClose: true,
                                    type: 'details',
                                },
                            ),
                        ),
                    useConfirm: true,
                    useCancel: false,
                }),
            );
        }

        return this.swapPlayerAndClosePopup();
    }

    swapPlayerAndClosePopup(): void {
        const {searchPlayer, replacePlayer, lineup, dispatch} = this.props;

        dispatch(Action.set('PlayersSwapped', searchPlayer, replacePlayer, lineup.lineupId));
        dispatch(closePopup());
    }

    render() {
        return (
            <button className="add-button" onClick={this.onClick.bind(this)}>
                <i className="fa fa-plus" />
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {lineups},
    } = state;

    return {
        lineups,
    };
}

export default connect(mapStatesToProps)(SwapPlayersButton);
